export default {
  balance: state => state.balance,
  balanceOrigin: state => state.balanceOrigin,
  balanceSms: state => (state.balance.length && state.balance.filter(item => item.channel == 'sms')[0].currentBalances) || [],
  balanceSmsOrigin: state => (state.balanceOrigin.length && state.balanceOrigin.filter(item => item.channel == 'sms')[0].currentBalances) || [],
  totoalCurrentBalanceOrigin: state => state.totalsBalanceChannelsOrigin,
  totalCurrentBalance: state => state.totalsBalanceChannels,
}
